import React, {useEffect, useState} from "react";
import {getItems, getRaw} from "../../../utils/communication";
import Pagination from "../../../components/pagination";
import {Link} from "react-router-dom";
import parseAnError from "../../../model/misc";

export default function CuisineTypeHome() {
    const [count, setCount] = useState<number>(1),
        [tools, setRecipes] = useState<CuisineType[]>([]),
        [offset, setOffset] = useState<number>(1),
        [error, setError] = useState<string | null>(null);

    useEffect(() => {
        document.title = "CuisineTypes - Hoarfroster";

        (async () => {
            let response = await getRaw("/cooking/tool/count");

            if (response.code !== 200) {
                setError(parseAnError(response.data).message);
            } else {
                setCount(Math.ceil((response.data.count as number) / 10));
            }
        })();
    }, []);

    useEffect(() => {
        let _ = getCuisineTypes((offset - 1) * 10);
    }, [offset, count]);

    const getCuisineTypes = async (offset: number) => {
        let response = await getItems<CuisineType>("/cooking/cuisineType/all?offset=" + offset + "&limit=10");

        if (response.code !== 200) {
            setError(parseAnError(response.data).message);
        } else {
            setRecipes(response.data as CuisineType[]);
        }
    }

    return (
        <main>
            <div className="container">
                <div className="content">
                    <h1>CuisineTypes</h1>

                    <table>
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tools.map(tool => (
                            <tr key={tool.publicId} className="py-4">
                                <td className="primary">{tool.name}</td>
                                <td>{tool.description}</td>
                                <td><Link to={"/cooking/tool/" + tool.publicId}>View</Link></td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    <Pagination currentPage={offset} totalPages={count} onPageChange={setOffset}/>

                    {error && <div className="error text-red-500 text-center">{error}</div>}
                </div>

                <div className="sidebar space-y-2">
                    <h2>About</h2>
                    <p>欢迎来看烤鹅普拉斯做客！这里有好吃的、好看的、好玩的各种新奇古怪的食谱菜单原材料工具！</p>
                    <p>微信小程序：烤鹅普拉斯</p>
                </div>
            </div>
        </main>
    );
}